export const MODULE_NAME = 'POPUP_VIEWED_MODULE_NAME';

export const ACTION_TYPE = {
  REQUEST_PENDING: `${MODULE_NAME}.REQUEST_PENDING`,
};

export const POPUP_VIEWED_MODULE_NAME = 'POPUP_VIEWED_MODULE_NAME';

export const API = {
  TYPE: 'POST',
  URL: (popupId: string) => `popup/viewed/${popupId}`,
};
